"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharmedEffectHandler = exports.CharmedEffectArgs = void 0;
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
const EffectType_1 = require("../EffectType");
class CharmedEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Charmed;
        this.__typeName = "Charmed";
        this.name = "Charmed";
        this.harmful = true;
    }
}
exports.CharmedEffectArgs = CharmedEffectArgs;
let CharmedEffectHandler = class CharmedEffectHandler {
    apply(sequence, container, state) {
        if (container.hasEffectOfType(state.targetId, EffectType_1.EffectType.CharmImmunity)) {
            state.meta.wasImmune = true;
            container.cancelEffect(sequence, state.id);
            return;
        }
        const charms = container.getEffectsOfType(state.targetId, EffectType_1.EffectType.Charmed).filter(other => other !== state.id);
        if (charms.length > 0) {
            return;
        }
        const creatorFaction = container.getFaction(state.creatorId);
        const currentFaction = container.getFaction(state.targetId);
        state.meta.startingFaction = charms.length > 0 ? container.getEffectMetaValue(charms[0], "Charmed", "startingFaction", currentFaction)
            : currentFaction;
        if (container.hasAi(state.targetId)) {
            const ai = container.getAi(state.targetId);
            state.meta.startingAiKey = charms.length > 0 ? container.getEffectMetaValue(charms[0], "Charmed", "startingAiKey", ai === null || ai === void 0 ? void 0 : ai.__typeName)
                : ai === null || ai === void 0 ? void 0 : ai.__typeName;
            state.meta.startingAiArgs = charms.length > 0 ? container.getEffectMetaValue(charms[0], "Charmed", "startingAiArgs", ai === null || ai === void 0 ? void 0 : ai.args)
                : ai === null || ai === void 0 ? void 0 : ai.args;
        }
        container.setFaction(sequence, state.targetId, creatorFaction);
        container.setAi(sequence, state.targetId, "Rando", {});
        const charmedAuraVfx = new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "head", "behind"), "Charmed");
        state.meta.vfxStepArgsId = charmedAuraVfx.id;
        sequence.pushSequence("sequential")
            .push(charmedAuraVfx)
            .push(new core_1.MoveCharacterVfxStepArgs(state.targetId, new LocationSelector_1.FactionOpenCellLocationSelector(enums_1.Faction[creatorFaction])));
    }
    remove(sequence, container, state) {
        if (state.meta.wasImmune) {
            return;
        }
        const charms = container.getEffectsOfType(state.targetId, EffectType_1.EffectType.Charmed)
            .filter(other => other !== state.id);
        if (charms.length > 0) {
            return;
        }
        container.setFaction(sequence, state.targetId, state.meta.startingFaction);
        if (state.meta.startingAiKey) {
            container.setAi(sequence, state.targetId, state.meta.startingAiKey, state.meta.startingAiArgs);
        }
        else {
            container.unsetAi(state.targetId);
        }
        sequence.pushSequence("sequential")
            .push(new core_1.MoveCharacterVfxStepArgs(state.targetId, new LocationSelector_1.FactionOpenCellLocationSelector(enums_1.Faction[state.meta.startingFaction])))
            .push(new core_1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
    }
};
CharmedEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Charmed)
], CharmedEffectHandler);
exports.CharmedEffectHandler = CharmedEffectHandler;
